import React, { 
  FunctionComponent, useCallback, useContext, useEffect, useRef, useState 
} from 'react';
import {
  Box,
  Breadcrumbs,
  Button,
  Divider,
  Grid,
  Link,
  Tab,
  Tabs,
  Theme,
  Toolbar,
  Typography,
} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import { Favorite, Share } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { Link as RouteLink, useHistory, useParams } from 'react-router-dom';
import _ from 'lodash';
import { filter, isUndefined, union } from 'lodash';
import { 
  getCatlogsAction, getControlsAction, getProductSelectionCgIDAction, 
  getProductSelectionRobotAction, getRobotLocalesAction, useModelOptions 
} from '@ivymobi/orbit-core/business/productCenter';
import { getAccountAction, useAccount, getSampleInfoAction, getSampleInfo2ButtonAction } from '@ivymobi/orbit-core/business/tenant';
import { getStatsAction, useStats } from '@ivymobi/orbit-core/business/stats';
import { modelOptionsAction, useOptions } from '@ivymobi/orbit-core/business/user';
import { getOutLibDocumentsAction, getICatalogDocumentsAction } from '@ivymobi/orbit-core/business/share';
import { getDocumentThumb, getFileType, Tenant } from '@ivymobi/orbit-core';
import { useDocument, getDocumentAction, useDocuments, getDocumentListByIds } from "@ivymobi/orbit-core/business/document";

import { TenantContext, UserContext, DeviceType, WebSiteContext } from '../orbit-context';
import QuickStart from '../dashboard/quickStart';
import Menus, { OpenMenuItem } from '../components/views/menuItem';

import { DocumentGridCard } from '../documents/grid';
import PreviewDialog from '../documents/preview';

// import Title from '../components/views/title';
// import { TabPanel } from '../components';
// import { IvymobiTabs } from '../components/IvymobiTabs';
// import RobotSearch from './component/robotSearch';
// import ProductItem from './component/productItem';
// import SelectionItem from './component/selectionItem';
// import ZTree from './component/zTree';
// import ControlPanel from './component/controlPanel';
// import { getTitle, getTitleById } from './mapping';

// import './selections.css'

const useStyles = makeStyles((theme: Theme) => createStyles({
  pages: {
    display: 'flex',
    flexDirection:'column',
    height:'100%',
    alignItems:'center'
  },
  sliderBar:{
    display: 'flex',
    flexDirection:'column',
    width:'25%',
    paddingTop:theme.spacing(6),
    paddingBottom:theme.spacing(2)
  },
  content:{
    flexGrow:1,
    flexBasis:0,
    display:'flex',
    // justifyContent:'center',
    alignItems:'center',
    flexDirection:'column',
    paddingTop:theme.spacing(6),
    paddingBottom:theme.spacing(2)
  }
}));

const queryParse = (query) => {
  query = query.substring(query.indexOf('?')+1);
  let array = query.split("&")
  let params = {};
  array.forEach(item => {
    let key = item.substring(0,item.indexOf('='));
    let value= decodeURIComponent(item.substring(item.indexOf('=')+1));
    params[key]= value;
  });
  return params;
}

function FileDocument(props) {
  const {
    document, onClose, onLikeFormOpen, share, user, handleDownload
  } = props;
  const { asset } = document;
  const dispatch = useDispatch();
  // file type
  const isFile = document.type === 'file';
  const fileType = isFile && getFileType(document.name);

  const isPreview = false;
  
  const onLeft = (e) => {

  };
  const onRight = () => {
    const anchor = window.document.createElement('a');
    const body = window.document.querySelector('body');
    anchor.href = asset.url;
    anchor.download = document.name;
    anchor.style.display = 'none';
    body.appendChild(anchor);
    anchor.click();
    body.removeChild(anchor); 
    window.URL.revokeObjectURL(anchor.href);
  };
  return (
    <Box style={{backgroundColor: '#2F3941', height:'100%'}}>
      <PreviewDialog type='share' handleDownload={handleDownload} user={user} document={document} onClose={onClose} share={share} isPreview={isPreview} onLikeFormOpen={onLikeFormOpen} />
      {/* <Toolbar /> */}
      {fileType !== 'pdf' &&  <Toolbar /> }
      {/* {fileType !== 'pdf' && <Toolbar 
        style={{
          position: 'fixed',  bottom: 0,
          width: '100%',
          display: 'flex', justifyContent: 'center'
        }}>
        <Button variant='contained'
          style={{ borderRadius: '16px', backgroundColor: '#39AC4A', color: 'white' }}
          onClick={onLikeFormOpen}
        >
          我感兴趣，请联系我
        </Button>

      </Toolbar>} */}
    </Box>
  );
}

export const DocumentView = (props) => {
  const { tenant } = props;
  const dispatch = useDispatch();
  const classes = useStyles(); 
  const history = useHistory();
  const deviceType = useContext(DeviceType);

  const { id } = useParams<any>() ?? {id: null};
  const params = queryParse(location.search);


  const [showData, setShowData] = useState(null)
  const [selectInfo, setSelectInfo] = useState({show: false, item: null, target: null});
  const [[anchorEl, selectId], setAnchorEl] = useState([null, null]);
  const [searchText, setSearchText] = useState('');
  // const [id, setId] = useState(null);
  const [result, setResult] = useState({result: [], onRefresh: false});
  const [value, setValue] = React.useState(0);
  const [flush, setFlush] = React.useState(false);
  const [robots, setRobots] = React.useState([]);
  const [useLoading, setUseLoading] = useState(false);
  const [documents, setDocuments] = useState({});
  const [{documentId, _bak_id, documentType}, setInfo] = useState({documentId: null, _bak_id: null, documentType: null});
  const [data, setData] = useState([])
  const [firstDocs,setFirstDocs] = useState([])

  const findPath = (dispatch, path, documents) => {
    const [docId] = path;
    const  doc = documents[docId];
    if (!doc) {
      console.log("333333333333")
     dispatch(getOutLibDocumentsAction({tenantId: tenant.id, id: docId })).then(res=>{
      let _docs = prev => res.reduce((acc, item) => {
        let id = '';
        if (item.type==='catalog'||item.type==='product') {
          id = item.realId;
        } else { 
          id = item.id;
        }
       
        acc[id] = item;
        return acc;
      }, {...prev});
      setDocuments(_docs)
     });
     return path;
    }
    const parentId = doc.parents?.[0];
    if (!parentId) {
      return path;
    }
    for(let i=0;i<firstDocs.length;i++){
      if(firstDocs[i]===doc.id){
        return path;
      }
    }
    return findPath(dispatch, [parentId, ...path], documents);
  }

  useEffect(() => {
    // console.log("===1111111111111111111111111111====", webInfo);
    dispatch(getSampleInfo2ButtonAction({ tenant: tenant, language: 'zh', user: { token: '' } })).then(res => {
      console.log("getSampleInfo2ButtonActiongetSampleInfo2ButtonAction----res==", res);
    });
  }, [dispatch, tenant]);

  // useEffect(() => {
  //   if (!tenant.id) return; 
  //   setUseLoading(true);
  //   // setDocuments([])
  //   // console.log("id==============================", id, tenant)
  //   if (id) {
  //     console.log("222222222222222")
  //     dispatch(getICatalogDocumentsAction({ tenantId: tenant?.id, id: id })).then((res) => {
  //       let docs = []
  //       for (let i = 0; i < res.length; i++) {
  //         docs.push(res[i].id)
  //       }
  //       setDocuments(prev => res.reduce((acc, item) => {
  //         let id = '';
  //         if (item.type === 'catalog' || item.type === 'product') {
  //           id = item.realId;
  //         } else { 
  //           id = item.id;
  //         }
  //         acc[id] = item;
  //         return acc;
  //       }, {...prev}));

  //       setUseLoading(false);
  //     });
  //   } else {
  //     console.log("1111111111111")
  //     dispatch(getICatalogDocumentsAction({ tenantId: tenant?.id, id: null })).then((res) => {
  //       console.log('资料库数据 == ', res)
  //       if (!id) {
  //         let docs = []
  //         for(let i = 0; i < res.length; i++) {
  //           docs.push(res[i].id)
  //         }
  //         setFirstDocs(docs)
  //       }
  //       setDocuments(prev => res.reduce((acc, item) => {
  //         let id = '';
  //         if (item.type === 'catalog' || item.type === 'product') {
  //           id = item.realId;
  //         } else { 
  //           id = item.id;
  //         }
  //         acc[id] = item;
  //         return acc;
  //       }, {...prev}));
  //       setUseLoading(false);
  //     });
  //   }
  // }, [dispatch, id, documentId, setDocuments, tenant]);

  let routers = [];
  if(documents[id]){
    routers = findPath(dispatch, [id], documents); 
  }

  // useEffect(() => {
  //   console.log("routers====",routers)
  //   // props.setTitle("行业应用案例")
  //   let ps= []
  //   let last = null;
  //   ps.push({ to:`/${params.catalogType}`,name:(getTitleById(params.catalogType)+(getTitleById(params.catalogType)==='伺服'?'系统':""))??'' })
  //   if(routers.length>0)
  //     ps.push({ to:`/${params.catalogType}/outlibs?catalogType=${params.catalogType}`,name:'资料下载'})
  //   for(let i=0;i<routers.length;i++){
  //     console.log("routers====",routers[i])
  //     if(i==(routers.length-1)){
  //       last = routers[i]
  //     }else
  //      ps.push({to:`/${params.catalogType}/outlibs/${documents[item]?.id}?catalogType=${params.catalogType}`,name:routers[i].name})
  //   }
  //   console.log("ps====",ps)
  //   props.setParents(ps)
  //   props.setTitle(last?.name??'资料下载')
  // },[])

  // useEffect(() => { 
  //   if (documents[id]?.type !== 'file' && documents[id]?.type !== 'weblink') {
  //     const data = ((documents[id] ? (documents[id].documents ? documents[id].documents : []) : firstDocs))
  //     .map(id => documents[id])
  //     .filter(i => i)
  //     .map(doc => ({
  //       ...doc,
  //       id: doc.id, 
  //       name: doc.name, 
  //       type: doc.type, 
  //       acl: doc.acl, 
  //       realId:doc.realId,
  //       thumbnail: getDocumentThumb(doc), 
  //       link : `/${params.catalogType}/outlibs/${doc.id}?catalogType=${params.catalogType}`
  //     }));
  //     setData(data);
  //   }
  // },[documents, id, firstDocs, dispatch])
 
  return (
    <div style={{height: deviceType === 'computer' ? 'calc(100% - 30px)' : '100%'}}>
      {deviceType === 'computer' && <Breadcrumbs style={{height:'30px'}} separator=">" maxItems={8}>
        <Link color='textPrimary' to={'/'} component={RouteLink}>首页</Link>
        {routers.length === 0 && <Typography color="textPrimary">资料下载</Typography>}
        {routers.length > 0 && <Link color='textPrimary' to={`/documents`} component={RouteLink}>资料下载</Link>}
        {routers.map((item, i) => {
          console.log('item==',item)
          return (
            <Link color='textPrimary' key={i} to={`/documents/${documents[item]?.id}`} component={RouteLink}>
              {documents[item]?.name} 
            </Link>
          )
        })}
      </Breadcrumbs>}

      <Box className={classes.pages}>
        <Box style={{
          width: deviceType === 'computer' ? '80%' : '100%', 
          paddingTop: deviceType === 'computer' ? '10px' : '0px',
          paddingBottom: deviceType === 'computer' ? '16px' : '0px',
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}> 
          <Box style={{
            flexGrow: '1',
            height: '0',
            background: 'white',
            padding: documents[id]?.type === 'file' ? '0px' : '20px',
            marginTop: deviceType === 'computer' ? '20px' : '0px',
            overflow: 'auto'
          }}>
            {(!documents[id] || documents[id]?.type==='folder') && <Grid container spacing={2} direction="row">
              {data.map(item => {
                return (<Grid item xs={6} sm={4} md={3}> 
                  <DocumentGridCard document={item} isWarning={true} onMenuClick={() => {}} onClick={(e,id) => {
                    // history.push("/robot/outLibs?id="+id)
                  }}/>
                </Grid>)
              })}
            </Grid>}

            {documents[id]?.type === 'file' && <Box style={{backgroundColor:'#e5e5e', height:'100%' }}>
              <FileDocument handleDownload={()=>{}} document={documents[id]}
                user={null} 
                share={null}
                onClose={() => {}}
                onLikeFormOpen={() => {}}
              />
            </Box>}
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default function DocumentContainer (props) {
  const tenant = useContext(TenantContext);
  return (
    <DocumentView tenant={tenant} {...props} />
  );
}